import { getHttpClient } from '../axiosInstance'

export const loadTasksForHome = async (queryParams) => {
  const apiClient = getHttpClient()
  const url = '/manager/tasks/v1/?sort=t.deadlineAt&direction=asc'

  const hiddenParams = { active: 1, flat: 0, current: undefined, pageSize: undefined }

  /**
   * It's also possible to remove and sanitize some parameters
   */
  const customQueryParams = { ...queryParams, ...hiddenParams }

  const response = await apiClient.get(url, { params: customQueryParams })
  return response.data
}

export const loadJobsForHome = async (queryParams) => {
  const apiClient = getHttpClient()
  const url = '/manager/jobs/v1/?sort=j.clientDeadlineAt&direction=asc'

  const hiddenParams = { active: 1, flat: 0, current: undefined, pageSize: undefined }

  /**
   * It's also possible to remove and sanitize some parameters
   */
  const customQueryParams = { ...queryParams, ...hiddenParams }

  const response = await apiClient.get(url, { params: customQueryParams })
  return response.data
}

export const loadQuotesForHome = async (queryParams) => {
  const apiClient = getHttpClient()
  const url = '/react/quotes/v1/?sort=q.clientDeadlineAt&direction=asc'

  const hiddenParams = { active: 1, flat: 0, current: undefined, pageSize: undefined }

  /**
   * It's also possible to remove and sanitize some parameters
   */
  const customQueryParams = { ...queryParams, ...hiddenParams }

  const response = await apiClient.get(url, { params: customQueryParams })
  return response.data
}
